import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IBusinessType, IBusinessTypeInitialState } from "./BusinessTypeModel";
import {
  BusinessTypeActiveInactive,
  createBusinessType,
  deleteBusinessType,
  findAllActiveBusinessType,
  getAllBusinessTypes,
  getBusinessTypeById,
  updateBusinessType,
} from "./services/businessType.services";

const initialState: IBusinessTypeInitialState = {
  loading: false,
  formLoading: false,
  error: "",
  BusinessTypeList: [],
  BusinessTypeID: null,
  BusinessTypeDetail: {
    BusinessType: "",
    ISActive: 1,
  },
};

export const BusinessTypeSlice = createSlice({
  name: "businessType",
  initialState,
  reducers: {
    clearBusinessTypeDetail: (state) => {
      state.BusinessTypeDetail = initialState.BusinessTypeDetail;
    },
    setBusinessTypeID: (state, action) => {
      state.BusinessTypeID = action.payload;
    },
    clearBusinessTypeID: (state) => {
      state.BusinessTypeID = null;
    },
    clearBusinessTypeList: (state) => {
      state.BusinessTypeList = [];
    },
  },
  extraReducers: (builder) => {
    /* For getAll Category */

    builder.addCase(getAllBusinessTypes.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllBusinessTypes.fulfilled,
      (state, action: PayloadAction<IBusinessType[]>) => {
        state.loading = false;
        state.BusinessTypeList = action.payload;
      }
    );
    builder.addCase(getAllBusinessTypes.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.BusinessTypeList = [];
    });

    /* For FindAllActiveCategory */

    builder.addCase(findAllActiveBusinessType.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      findAllActiveBusinessType.fulfilled,
      (state, action: PayloadAction<IBusinessType[]>) => {
        state.loading = false;
        state.BusinessTypeList = action.payload || [];
      }
    );
    builder.addCase(findAllActiveBusinessType.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.BusinessTypeList = [];
    });

    /* For createCategory */

    builder.addCase(createBusinessType.pending, (state) => {
      state.formLoading = false;
      state.error = "";
    });
    builder.addCase(createBusinessType.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(createBusinessType.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });

    /* For updateCategory */

    builder.addCase(updateBusinessType.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(updateBusinessType.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(updateBusinessType.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });

    /* For DeleteCategory */

    builder.addCase(deleteBusinessType.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteBusinessType.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteBusinessType.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    /* For ActiveInactiveCategory */

    builder.addCase(BusinessTypeActiveInactive.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(BusinessTypeActiveInactive.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(BusinessTypeActiveInactive.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    /* For CategoryById */

    builder.addCase(getBusinessTypeById.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(getBusinessTypeById.fulfilled, (state, action: any) => {
      state.formLoading = false;
      state.BusinessTypeDetail = action.payload;
    });
    builder.addCase(getBusinessTypeById.rejected, (state, action) => {
      state.formLoading = false;
      state.BusinessTypeDetail = initialState.BusinessTypeDetail;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const {
  setBusinessTypeID,
  clearBusinessTypeDetail,
  clearBusinessTypeID,
  clearBusinessTypeList,
} = BusinessTypeSlice.actions;
export default BusinessTypeSlice.reducer;
